import type { ReactNode } from "react";

import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

import { readSidebarOpen } from "./sidebarState";
import { SystemThemeSync } from "./SystemThemeSync";
import { VoltSidebar } from "./VoltSidebar";

/** Desktop frame: Volt sidebar on the left, the CRM page on the right. */
export const VoltShell = ({ children }: { children: ReactNode }) => (
  <SidebarProvider defaultOpen={readSidebarOpen(document.cookie)}>
    <SystemThemeSync />
    <VoltSidebar />
    <div className="min-w-0 flex-1">
      <div className="sticky top-0 z-10 flex h-12 items-center border-b bg-background px-2">
        <SidebarTrigger />
      </div>
      {children}
    </div>
  </SidebarProvider>
);
